
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import FieldMixin from '~/mixins/field.mixin';
import { Device } from '~/interfaces/device.interface';

@Component
export default class Secret extends Mixins(FieldMixin) {
    @Prop() device!: Device;

    isShowSecretShown = true;
    isShowSkeletonLoaderShown = false;

    @Watch('device')
    handler(device: Device) {
        if (!device.secret_key) {
            this.isShowSecretShown = true;
        } else {
            this.isShowSecretShown = false;
        }
    }

    async getDeviceSecret() {
        try {
            this.isShowSecretShown = false;
            this.isShowSkeletonLoaderShown = true;
            await this.device.getDeviceSecret();
        } catch (error) {
            this.isShowSecretShown = true;
        } finally {
            this.isShowSkeletonLoaderShown = false;
        }
    }

    downloadSecret() {
        if (this.device && this.device.secret_key) {
            const blob = new Blob([this.device.secret_key], { type: 'text/plain;charset=utf-8' });
            // remove ':' from mac for file name
            const mac = this.device.id.replace(/:/g, '');
            const type = this.device.type;
            const hw_version = this.device.hw_version;
            const a = document.createElement('a');
            a.href = window.URL.createObjectURL(blob);
            a.download =  `${mac}-${mac}.${type}.0.${hw_version}.0.csv`;
            a.click();
        }
    }
}
